import { useCallback } from "react"
import { useConfig } from "wagmi"
import { reconnect } from "wagmi/actions"
import { useConnectors } from "../../hooks/useConnectors"

export function useWithConnectorErrorRetry() {
  const config = useConfig()
  const { activeConnector } = useConnectors()

  return useCallback(
    async <R, T extends () => Promise<R>>(fn: T): Promise<R> => {
      try {
        return await fn()
      } catch (error) {
        if (
          error instanceof Error &&
          (error.message.includes("Connector not connected") ||
            error.message.includes("connector.getChainId is not a function"))
        ) {
          const connectors =
            activeConnector && activeConnector.chainArch === "EVM"
              ? [activeConnector.baseConnector]
              : []
          await reconnect(config, { connectors })
          return await fn()
        }
        throw error
      }
    },
    [activeConnector, config],
  )
}
